import { Pipe, PipeTransform } from "@angular/core";


//SUBMITTED, PAID, RETURNED_NOK, RETURNED_OK, RESUBMITTED, CANCELED, In_Bearbeitung
@Pipe({
  name: "AbsetzungsStatus"
})
export class AbsetzungsStatusPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    var HeaderText = "";


    switch (value) {
      case 0:
        HeaderText = "SUBMITTED";
        break;
      case 1:
        HeaderText = "Bezahlt";
        break;
      case 2:
        HeaderText = "Absetzung korrigiert";
        break;
      case 3:
        HeaderText = "Absetzung";
        break;
      case 4:
        HeaderText = "RESUBMITTED";
        break;
      case 5:
        HeaderText = "Stornieren";
        break;
      case 6:
        HeaderText = "In Bearbeitung";
        break;
    }

    return `${HeaderText}`;

  }
}
